import React from "react";
import { PaymentLayout as Layout } from "../shared/Layout";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { CheckCircleIcon } from "../../../assets/Icons/CheckCircleIcon";

export function PaymentSuccess() {
  const { tCommon: t } = useAppTranslation.Common();

  return (
    <Layout>
      <Layout.Icon type="success">
        <CheckCircleIcon />
      </Layout.Icon>
      <h2>{t("payment.success.title")}</h2>
      <Layout.Description>
        <p>{t("payment.success.message")}</p>
      </Layout.Description>
    </Layout>
  );
}
